module.exports = __webpack_public_path__ + "static/media/s2.620c0c06.svg";